const CROWNPEAK_COOKIE_NAME = '__Secure-dbx_consent';
const ANALYTICS_CATEGORY = 'analytics';
const ALL_CATEGORY = 'all';
const NAVATTIC_MESSAGE_KIND = 'navattic:set-cookie-consent';

const DEFAULT_CONSENT = {
  events: false,
  forms: false
};

const getBrowserWindow = () => {
  if (typeof window === 'undefined') return null;
  return window;
};

const debugNavatticConsent = (message, data = {}, level = 'log') => {
  const browserWindow = getBrowserWindow();
  if (!browserWindow) return;

  const logger = browserWindow.console?.[level] || browserWindow.console?.log;
  logger?.call(browserWindow.console, `[Navattic consent] ${message}`, data);
};

const normalizeConsent = (consent = DEFAULT_CONSENT) => ({
  events: Boolean(consent.events),
  forms: Boolean(consent.forms)
});

const isNavatticIframe = (iframe) => iframe?.src?.includes('navattic.com');

const getCookieValue = (cookieName) => {
  const browserWindow = getBrowserWindow();
  if (!browserWindow?.document?.cookie?.includes(`${cookieName}=`)) {
    debugNavatticConsent('Consent cookie not found', { cookieName }, 'warn');
    return null;
  }

  return browserWindow.document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((row) => row.startsWith(`${cookieName}=`))
    ?.substring(cookieName.length + 1);
};

const parseCookieValue = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(decodeURIComponent(value));
  } catch (_decodeError) {
    try {
      return JSON.parse(value);
    } catch (_parseError) {
      debugNavatticConsent('Unable to parse consent cookie value', { value }, 'warn');
      return null;
    }
  }
};

export const getNavatticCookieConsentFromCategories = (categories) => {
  const enabled = Boolean(
    categories &&
      (categories[ANALYTICS_CATEGORY] === true || categories[ALL_CATEGORY] === true)
  );

  return {
    events: enabled,
    forms: enabled
  };
};

export const getNavatticCookieConsentFromCookie = () => {
  const consentCookie = parseCookieValue(getCookieValue(CROWNPEAK_COOKIE_NAME));
  return getNavatticCookieConsentFromCategories(consentCookie?.categories);
};

export const sendNavatticCookieConsentToIframe = (
  iframe,
  consent = getNavatticCookieConsentFromCookie()
) => {
  if (!iframe) {
    debugNavatticConsent('Skipped sending message because iframe is missing', {}, 'warn');
    return;
  }

  if (!iframe.contentWindow) {
    debugNavatticConsent('Skipped sending message because iframe contentWindow is missing', {
      src: iframe.src
    }, 'warn');
    return;
  }

  if (!isNavatticIframe(iframe)) {
    debugNavatticConsent('Skipped sending message because iframe is not Navattic', {
      src: iframe.src
    }, 'warn');
    return;
  }

  const normalizedConsent = normalizeConsent(consent);

  iframe.contentWindow.postMessage(
    {
      kind: NAVATTIC_MESSAGE_KIND,
      value: normalizedConsent
    },
    '*'
  );
};
